import React from 'react';

import * as S from './OfferCarouselLoader.styles';

const OfferCarouselLoader = () => {
  return (
    <S.BannerLoaderContainer>
      <S.BannerLoaderOuterWrap>
        <S.OfferHeadTextLoader></S.OfferHeadTextLoader>
        <S.OfferBlockLoader>
          <S.BannerLoaderInnerWrap>
            <S.OfferImageLoaderFirst></S.OfferImageLoaderFirst>
            <S.OfferImageLoaderSecond></S.OfferImageLoaderSecond>
            <S.OfferImageLoaderThird></S.OfferImageLoaderThird>
          </S.BannerLoaderInnerWrap>
          <S.BannerLoaderInnerWrap>
            <S.OfferImageLoaderFirst></S.OfferImageLoaderFirst>
            <S.OfferImageLoaderSecond></S.OfferImageLoaderSecond>
            <S.OfferImageLoaderThird></S.OfferImageLoaderThird>
          </S.BannerLoaderInnerWrap>
          <S.BannerLoaderInnerWrap>
            <S.OfferImageLoaderFirst></S.OfferImageLoaderFirst>
            <S.OfferImageLoaderSecond></S.OfferImageLoaderSecond>
            <S.OfferImageLoaderThird></S.OfferImageLoaderThird>
          </S.BannerLoaderInnerWrap>
        </S.OfferBlockLoader>
      </S.BannerLoaderOuterWrap>
    </S.BannerLoaderContainer>
  );
};

export default OfferCarouselLoader;
